import { gql } from "graphql-tag"

export default gql`
  type Outlet {
    bio: String
    createdAt: String!
    domain: String!
    id: ID!
    isPublished: Boolean!
    logoImageId: ID
    name: String!
    publishedAt: String
    slug: String!
    socialLinks: SocialLinks
    splashImageId: ID
    updatedAt: String!
    url: String!
  }

  input OutletAddInput {
    bio: String
    domain: String!
    isPublished: Boolean!
    logoImageId: ID
    name: String!
    publishedAt: String
    slug: String!
    socialLinksId: ID
    splashImageId: ID
    url: String!
  }

  input OutletUpdateInput {
    bio: String
    domain: String
    isPublished: Boolean
    logoImageId: ID
    name: String
    publishedAt: String
    slug: String
    socialLinksId: ID
    splashImageId: ID
    url: String
  }

  input GetQueryOutlets {
    createdAt: String
    isAscending: Boolean
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input GetWaveQueryOutlets {
    createdAt: String
    cursor: String
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input SearchOutletsInput {
    name: String
  }
`
